const fromBetslip = require('./fromBetslip');
const fromBasket = require('./fromBasket');
const { AchievementValidator: Validator } = require('../../types');

const validatorFromBetslip = {
  [Validator.IS_BET_AMOUNT_GREATER_OR_EQUAL_THAN]: fromBetslip.isBetAmountGreaterOrEqualThan,
  [Validator.IS_ODD_GREATER_OR_EQUAL_THAN]: fromBetslip.isOddGreaterOrEqualThan,
  [Validator.IS_BET_CENTS_VALID]: fromBetslip.isBetCentsValid,
  [Validator.IS_LIVE]: fromBetslip.isLive,
  [Validator.IS_PREMATCH]: fromBetslip.isPrematch,
  [Validator.IS_SPORT_ID_VALID]: fromBetslip.isSportIdValid,
  [Validator.IS_CATEGORY_ID_VALID]: fromBetslip.isCategoryIdValid,
  [Validator.IS_TOURNAMENT_ID_VALID]: fromBetslip.isTournamentIdValid,
  [Validator.IS_MATCH_ID_VALID]: fromBetslip.isMatchIdValid,
  [Validator.IS_BET_TYPE_VALID]: fromBetslip.isBetTypeIdValid,
  [Validator.IS_SIMPLE_BET]: fromBetslip.isSimpleAndNotMyMatch,
  [Validator.IS_COMBINED_BET]: fromBetslip.isCombined,
  [Validator.HAS_MYMATCH]: fromBetslip.hasMyMatch,
  [Validator.IS_MIN_COMBINED_BET_VALID]: fromBetslip.isMinCombinedBetsValid,
  [Validator.IS_MIN_MYMATCH_LINE_VALID]: fromBetslip.isMinMyMatchLineValid,
  [Validator.IS_MIN_ODD_IN_COMBINED_VALID]: fromBetslip.isMinOddInCombinedValid,
  [Validator.IS_STARTING_BEFORE_MAX_START_DATE]: fromBetslip.isStartingBeforeMaxStartDate,
  [Validator.IS_STARTING_AFTER_MIN_START_DATE]: fromBetslip.isStartingAfterMinStartDate,
  [Validator.IS_NOT_SYSTEM]: fromBetslip.not(fromBetslip.isSystem),

  [Validator.HAS_FREEBET]: fromBetslip.hasFreebet,
  [Validator.HAS_BOOSTED_ODDS]: fromBetslip.hasBoostedOdd,
  [Validator.HAS_OUTRIGHT]: fromBetslip.hasOutright,
  [Validator.HAS_NO_OUTRIGHT_BUT_BOOSTED_ODDS]: fromBetslip.hasNoOutrightBuBoostedOdd,

  [Validator.HAS_NO_SPORTS_IN]: fromBetslip.hasNoSportIdsIn,
  [Validator.HAS_NO_CATEGORIES_IN]: fromBetslip.hasNoCategoryIdsIn,
  [Validator.HAS_NO_TOURNAMENTS_IN]: fromBetslip.hasNoTournamentIdsIn,
  [Validator.HAS_NO_MATCHES_IN]: fromBetslip.hasNoMatchIdsIn,
  [Validator.HAS_NO_BET_TYPES_IN]: fromBetslip.hasNoBetTypesIn,
};

const validatorFromBasket = {
  [Validator.IS_BET_AMOUNT_GREATER_OR_EQUAL_THAN]: fromBasket.isBetAmountGreaterOrEqualThan,
  [Validator.IS_ODD_GREATER_OR_EQUAL_THAN]: fromBasket.isOddGreaterOrEqualThan,
  [Validator.IS_BET_CENTS_VALID]: fromBasket.isBetCentsValid,
  [Validator.IS_LIVE]: fromBasket.isLive,
  [Validator.IS_PREMATCH]: fromBasket.isPrematch,
  [Validator.IS_SPORT_ID_VALID]: fromBasket.isSportIdValid,
  [Validator.IS_CATEGORY_ID_VALID]: fromBasket.isCategoryIdValid,
  [Validator.IS_TOURNAMENT_ID_VALID]: fromBasket.isTournamentIdValid,
  [Validator.IS_MATCH_ID_VALID]: fromBasket.isMatchIdValid,
  [Validator.IS_BET_TYPE_VALID]: fromBasket.isBetTypeIdValid,
  [Validator.IS_SIMPLE_BET]: fromBasket.isSimpleAndNotMyMatch,
  [Validator.IS_COMBINED_BET]: fromBasket.isCombined,
  [Validator.HAS_MYMATCH]: fromBasket.hasMyMatch,
  [Validator.IS_MIN_COMBINED_BET_VALID]: fromBasket.isMinCombinedBetsValid,
  [Validator.IS_MIN_MYMATCH_LINE_VALID]: fromBasket.isMinMyMatchLineValid,
  [Validator.IS_MIN_ODD_IN_COMBINED_VALID]: fromBasket.isMinOddInCombinedValid,
  [Validator.IS_STARTING_BEFORE_MAX_START_DATE]: fromBasket.isStartingBeforeMaxStartDate,
  [Validator.IS_STARTING_AFTER_MIN_START_DATE]: fromBasket.isStartingAfterMinStartDate,
  [Validator.IS_NOT_SYSTEM]: fromBasket.not(fromBasket.isSystem),

  [Validator.HAS_FREEBET]: fromBasket.hasFreebet,
  [Validator.HAS_BOOSTED_ODDS]: fromBasket.hasBoostedOdds,
  [Validator.HAS_OUTRIGHT]: fromBasket.hasOutright,
  [Validator.HAS_NO_OUTRIGHT_BUT_BOOSTED_ODDS]: fromBasket.hasNoOutrightButBoostedOdds,

  [Validator.HAS_NO_SPORTS_IN]: fromBasket.hasNoSportIdsIn,
  [Validator.HAS_NO_CATEGORIES_IN]: fromBasket.hasNoCategoryIdsIn,
  [Validator.HAS_NO_TOURNAMENTS_IN]: fromBasket.hasNoTournamentIdsIn,
  [Validator.HAS_NO_MATCHES_IN]: fromBasket.hasNoMatchIdsIn,
  [Validator.HAS_NO_BET_TYPES_IN]: fromBasket.hasNoBetTypesIn,
};

module.exports = {
  Validator,
  validatorFromBasket,
  validatorFromBetslip,
};
